// Import react libs
import { useState, useEffect } from 'react';

// Import lib
import filterProductList from '../libs/filterProductList';

// Hook to filter a product list based on a query string
export function useFilterProductList(productList, queryString) {
    // States to store filtered product list
    const [filteredProductList, setFilteredProductList] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        // Reset the states each time the query and product list changes
        setFilteredProductList(null);
        setIsLoading(true);
        setIsError(false);

        try {
            // Try to filter the product list
            setFilteredProductList(filterProductList(productList, queryString));
        } catch (err) {
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    }, [productList, queryString]);

    return { filteredProductList, isLoading, isError };
}
